import { Button } from '@travelnest/merlin.button';
import { Rule } from '@travelnest/merlin.rule';
import * as React from 'react';
import { NavTile } from '../../components/nav-tile/NavTile';
import { Content } from '../../components/page';

interface IErrorPageProps {
	error?: any;
	info?: any;
}

interface IErrorPageState {
	showErrors: boolean;
}

export class ErrorPage extends React.Component<IErrorPageProps, IErrorPageState> {
	public toggleErrors() {
		this.setState({
			showErrors: !(this.state && this.state.showErrors)
		});
	}

	public render() {
		const { error, info } = this.props;
		const showErrors = (this.state && this.state.showErrors);
		return (
			<>
				<Content>
					<h1>Uh-oh!</h1>
					<Rule />
					<h3>There was a problem loading this page.</h3>
					<p>You can navigate back in your browser, or return to the dashboard below.</p>
					<p>If the problem continues, please contact customer support who will be happy to help you.</p>
					<NavTile
						label="Return to dashboard"
						to="/">
					</NavTile>
					{!(error || info) ? null : <React.Fragment>
						<Button onClick={() => this.toggleErrors()}>{showErrors ? 'Hide' : 'Show'} details</Button>
						{!showErrors ? null : <div>
							<pre>{error.stack ? error.stack : JSON.stringify(error)}</pre>
							<pre>{info.componentStack ? info.componentStack : JSON.stringify(info)}</pre>
						</div>}
					</React.Fragment>}
				</Content>

			</>
		);
	}
}
